<template>
  <div class="w-px flex-initial flex-shrink-0 bg-gray-300 dark:bg-gray-700" />
</template>
